import BodyText from '@lyra/core/components/BodyText'
import Heading from '@lyra/core/components/Heading'
import HeadingNumberAnimated from '@lyra/core/components/HeadingNumberAnimated'
import Icon, { ChevronRight } from '@lyra/core/components/Icon'
import Section, { SectionProps } from '@lyra/core/components/Section'
import formatUSD from '@lyra/core/utils/formatUSD'
import { PageId } from '@lyra/web/constants/pages'
import useTotalAccountValue from '@lyra/web/hooks/useTotalAccountValue'
import { getPagePath } from '@lyra/web/utils/pages'
import { useRouter } from 'next/navigation'
import React from 'react'
import { XStack } from 'tamagui'

type Props = { isLink?: boolean; isAnimated?: boolean } & SectionProps

export default function BalanceHeaderSection({ isLink, isAnimated, ...sectionProps }: Props) {
  const { data, isLoading, error } = useTotalAccountValue()
  const router = useRouter()

  return (
    <Section
      {...sectionProps}
      onPress={isLink ? () => router.push(getPagePath({ page: PageId.Balances })) : undefined}
      isClickable={isLink}
    >
      <Section.YStack>
        <BodyText size="lg" color="secondary">
          Balance
        </BodyText>
        <XStack alignItems="center" gap="$2">
          {isAnimated && !isLoading && !error && data ? (
            <HeadingNumberAnimated
              size="h2"
              value={data.totalValue}
              showColorChange
              isDollarFormat
            />
          ) : (
            <Heading size="h2">
              {!isLoading && !error && data ? formatUSD(data.totalValue) : '...'}
            </Heading>
          )}
          {isLink && data ? <Icon icon={<ChevronRight />} size={24} color="secondary" /> : null}
        </XStack>
      </Section.YStack>
    </Section>
  )
}
